<template>
  <h3 v-if="headline" class="headline-related-title" :class="classModifier">
    <link-handler :href="headline.href" v-html="getTitle(headline)" />{{ '\xa0'
    }}<link-handler
      v-if="headline.comments && headline.comments.enabled && headline.comments.count > 49"
      :href="`${headline.href}/${$t('portal_core.comments')}`"
      class="headline-related-title__comments-count"
    >
      <span class="comment-count">({{ headline.comments.count }})</span>
    </link-handler>
  </h3>
</template>
<script lang="ts">
import Vue from 'vue';
import { HeadlineWithRelatedArticles } from '@headlines/types/headline';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import getItemFromObject from 'lodash/get';
import { stripTags } from '@root/common/filters/htmlFormater';

interface Props {
  headline: HeadlineWithRelatedArticles;
  separator: boolean;
}

interface Computed {
  classModifier: Record<string, any>;
}

interface Methods {
  getItemFromObject: typeof getItemFromObject;
  getTitle: (headline: HeadlineWithRelatedArticles, strip: boolean) => string;
}

export default Vue.extend<unknown, Methods, Computed, Props>({
  components: {
    LinkHandler,
  },
  props: {
    headline: {
      type: Object,
      required: true,
    },
    separator: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    classModifier() {
      return { 'headline-related-title--with-separator': this.separator };
    },
  },
  methods: {
    getItemFromObject,
    getTitle(headline, strip = false) {
      const title = headline.content.title?.html
        ? headline.content.title?.html.replace(/(<\/?h1>)/gi, '')
        : headline.content.title?.text
          ? headline.content.title?.text
          : '';

      return strip && typeof stripTags === 'function' ? stripTags(title) : title;
    },
  },
});
</script>
<style lang="scss">
.headline-related-title {
  position: relative;
  padding: 0 0 0 16px;
  margin: 10px 0 0;
  font-size: 13px;
  font-weight: get-font-weight('regular');
  color: get-color('grey-1');

  &--with-separator {
    &:before {
      content: '';
      position: absolute;
      top: -18px;
      left: 0;
      width: 294px;
      max-width: 100%;
      height: 1px;
      background-color: get-color('grey-2');

      @include media-breakpoint-down(lg) {
        width: 188px;
      }
    }
  }

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 5.5px;
    width: 8px;
    height: 8px;
    background-color: get-color('color-1');
    border-radius: 50%;
  }

  &__comments-count {
    color: get-color('link-2');
    margin-left: 3px;
  }
}
</style>
